// Shared between the student portal request form and the admin Requests
// page, so both present the exact same set of request types.
// Add new request types here as they become supported.
export const REQUEST_TYPE_OPTIONS = [
  { value: 'Medical Leave', label: 'Medical Leave' },
  { value: 'Withdrawal', label: 'Withdrawal' },
  { value: 'Deferment', label: 'Deferment' },
  { value: 'Complaint', label: 'Complaint' },
  { value: 'Feedback', label: 'Feedback' },
];

// Request types that need a start/end date range.
export const DATE_RANGE_TYPES = new Set(['Medical Leave']);
